<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-17 09:16:39
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-11-30 11:12:59
 * @FilePath: \miniproweb\src\views\Popularization\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="myBody">
    <div class="poptitle">风险普查</div>
    <van-cell title="测试文章" v-for="item in list" @click="gotoPage(item)">
      <template #title>
        <span class="custom-title">{{item.name}}</span>
      </template>
    </van-cell>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          name: "干旱",
          value: "fxpc_drought"
        },
        {
          name: "冰雹",
          value: "fxpc_hail"
        },
        {
          name: "高温",
          value: "fxpc_highTem"
        },
        {
          name: "低温",
          value: "fxpc_lowTem"
        },
        {
          name: "暴雨",
          value: "fxpc_Rain"
        },
        {
          name: "雪灾",
          value: "fxpc_snow"
        },
        {
          name: "大风",
          value: "fxpc_wind"
        },
        {
          name: "风险普查报告",
          value: "fxpc_report"
        }
      ]
    };
  },
  methods: {
    gotoPage(data) {
      this.$router.push({
        path: `/DocPage/${JSON.stringify(data)}`
      });
    }
  }
};
</script>

<style>
.poptitle {
  height: 50px;
  width: 100%;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  color: #1f8cf7;
}
.myBody {
  height: 100vh;
  width: 100vw;
  overflow-y: auto;
}
</style>